import { render, staticRenderFns } from "./StatementDescriptor.vue?vue&type=template&id=4aa11466&lang=pug"
import script from "./StatementDescriptor.vue?vue&type=script&lang=js"
export * from "./StatementDescriptor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports